import { useEffect } from 'react';

const parseShortcut = (shortcut: string) => {
  const keys = shortcut.toLowerCase().split('+');
  return {
    ctrl: keys.includes('ctrl'),
    alt: keys.includes('alt') || keys.includes('option'),
    shift: keys.includes('shift'),
    meta: keys.includes('cmd') || keys.includes('meta'),
    key: keys.find((k) => !['ctrl', 'alt', 'option', 'shift', 'cmd', 'meta'].includes(k)),
  };
};

export const useKeyboardShortcut = ({
  shortcut,
  onSuccess,
  requiresSecret = undefined,
}: {
  shortcut: string;
  onSuccess: () => void;
  requiresSecret?: string;
}) => {
  useEffect(() => {
    const config = parseShortcut(shortcut);

    const handleKeyDown = (e: KeyboardEvent) => {
      if (requiresSecret && localStorage.getItem(requiresSecret) !== 'true') {
        return;
      }
      if (
        Boolean(config.ctrl) === Boolean(e.ctrlKey) &&
        Boolean(config.alt) === Boolean(e.altKey) &&
        Boolean(config.shift) === Boolean(e.shiftKey) &&
        Boolean(config.meta) === Boolean(e.metaKey) &&
        e.key.toLowerCase() === config.key
      ) {
        onSuccess();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [shortcut, onSuccess, requiresSecret]);
};
